import { c as _c } from "react/compiler-runtime";
import { useCompanyId } from "@context-providers/company-id-provider";
import { resetActiveMembersState } from "@store/active-members/active-members-slice";
import { fetchActiveMembers } from "@store/active-members/active-members-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
import { useEffect } from "react";

/**
 * Fetches the active members of the selected workspace into the store when the calling component
 * mounts or the workspace changes, and clears them again when it unmounts.
 *
 * Clearing them also makes the store ignore a response that arrives afterwards, so that it neither
 * shows the members of the workspace the user left nor keeps the next fetch from running. Users
 * that may not read them get a rejected request that leaves them empty.
 *
 * @param shouldFetch Whether to fetch the active members at all
 */
export function useFetchActiveMembers(shouldFetch) {
  const $ = _c(5);
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  let t0;
  let t1;
  if ($[0] !== companyId || $[1] !== dispatch || $[2] !== shouldFetch) {
    t0 = () => {
      if (!shouldFetch) {
        return;
      }
      dispatch(fetchActiveMembers({
        companyId
      }));
      return () => {
        dispatch(resetActiveMembersState());
      };
    };
    t1 = [companyId, dispatch, shouldFetch];
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = shouldFetch;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
}